/**
 * LPR · item de menu del reporte "Control vehicular (LPR)" · helpers PUROS y SIN IMPORTS.
 *
 * 🔴 Este archivo no importa nada, y tiene que seguir asi. Lo usa BuildingService, que es
 * un servicio raiz y va en el bundle INICIAL del portal (lo carga el interceptor de
 * sesion): todo lo que se importe desde aqui lo descargan tambien el login, los residentes
 * y los guardias, tengan o no LPR. Por eso estos dos helpers no viven en lpr-report.ts,
 * que trae moment, lpr-visit.ts y los helpers de la pantalla del reporte.
 *
 * lpr-report.ts los re-exporta: la pantalla del reporte y su spec (lpr-report.spec.ts) los
 * siguen tomando de ahi.
 */

/**
 * Lo que respondio GET lpr/status para UN sitio. `report` = alguna camara LPR de salida,
 * activa, cubre al sitio: es lo unico que hace visible el item de menu. `checkout` =
 * alguna de ellas marca la salida en el Visitor Log. Cualquier respuesta que no sea
 * exactamente `true` deja el valor en false.
 */
export function lprSiteStatus(building: any, response: any): { building: any, report: boolean, checkout: boolean } {
    const lpr = response && response.lpr && typeof response.lpr === 'object' ? response.lpr : {};
    return {
        building: building === undefined ? null : building,
        report: lpr.report === true,
        checkout: lpr.checkout === true,
    };
}

/**
 * ¿Se muestra el item del reporte? Solo si el API dijo `report: true` para el sitio que
 * esta seleccionado AHORA: un estado que quedo de otro sitio no cuenta.
 */
export function lprReportMenuVisible(status: any, building: any): boolean {
    return !!status && status.report === true
        && building !== null && building !== undefined && building !== '' && status.building === building;
}
